<!--SKU编辑  -->
<template>
	<el-dialog
		title="数据字典信息"
		:visible.sync="dialogVisible"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		width="600px">
		<div class="form-box">
			<el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
				<div class="flex flex-between">
					<el-form-item label="名称" prop="codesetName">
						<el-input v-model.trim="dataForm.codesetName" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="编码" prop="codesetCode">
						<el-input v-model.trim="dataForm.codesetCode" maxlength="20"></el-input>
					</el-form-item>
				</div>
				<el-form-item label="备注" prop="remark">
					<el-input v-model.trim="dataForm.remark" type="textarea" :rows="2" maxlength="100"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="dialogVisible = false">取 消</el-button>
			<el-button size="small" type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				dataForm: {
					codesetName: '',
					codesetCode: '',
					remark: ''
				},
				rules: {
					codesetName: [
						{
							required: true,
							message: '名称不能为空',
							trigger: 'blur'
						}
					],
					codesetCode: [
						{
							required: true,
							message: '编码不能为空',
							trigger: 'blur'
						}
					],
				}
			}
		},
		created() {

		},
		methods: {
			init(dt) {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.dataForm.resetFields();
					delete this.dataForm.codesetId;
					if(dt) {
						this.dataForm.codesetId = dt.codesetId;
						this.dataForm.codesetName = dt.codesetName;
						this.dataForm.codesetCode = dt.codesetCode;
						this.dataForm.remark = dt.remark;
					}
				})
			},
			handleSubmit:debounce(function() {
				if(this.dialogVisible == false) {
					return
				}
				this.$refs['dataForm'].validate(valid => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
						let that = this;
						that.$request.post(
							that.dataForm.codesetId ? 'updateSysCodeSet' : 'addSysCodeSet',
							true,
							that.dataForm
						)
						.then((res) => {
							if (res) {
								that.dialogVisible = false;
								that.$emit('getSysCodeSetList');
								that.$message.success('保存成功');
							}
						})
						}).catch(() => {});
					} else {
						return false;
					}
				});
			},1000,true),
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

</style>
